import { WorkstationItem } from './WorkstationItem/WorkstationItem'
import styles from './Area.module.scss'
import { useAreaStore } from '@/modules/Areas/store'
import { InactiveWorkstationItem } from './WorkstationItem/InactiveWorkstationItem'
import { AreaHistory } from '@/types/area'

export const Area = ({ area }: { area: AreaHistory }) => {
    const { selectedAreaCode } = useAreaStore()

    const filteredWorkstations =
        selectedAreaCode === 'night'
            ? area.workstations.filter((workstation) => workstation.isNightNetwork)
            : area.workstations

    if (filteredWorkstations.length === 0) return null

    return (
        <div className={styles.area}>
            {selectedAreaCode === 'all' && <div className={styles.title}>{area.title}</div>}

            <div className={styles.workstationsContainer}>
                {filteredWorkstations.map((workstation) =>
                    workstation.routes.length === 0 ? (
                        <InactiveWorkstationItem key={workstation.number} workstation={workstation} />
                    ) : (
                        <WorkstationItem key={workstation.number} workstation={workstation} />
                    )
                )}
            </div>
        </div>
    )
}
